import TermlyScriptWrapper from "../components/TermlyScriptWrapper";

const TermsAndServicePage = () => {
  return <TermlyScriptWrapper dataId="854c64f1-24a9-4a3b-8d18-0d9275c5754c" />;
};

export default TermsAndServicePage;
